export default "/images/mic-off.svg?bdfa9d85026a8db0737dc299f928ff3c";